import React from 'react';
import { FormContext, useForm } from 'react-hook-form';
import { useMountedSafeState } from 'features/sendouts/hooks/useMountedSafeState';
import strings from 'strings';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { getInterviewTimeValidationError } from '../CreateSendoutDrawer/CreateSendoutDrawer.utils';
import { FORM_FIELDS_MAP } from '../CreateSendoutDrawer/SendoutForm/SendoutForm.constants';

import { buildCreateSendoutInterviewPayload } from './CreateSendoutInterviewDrawer.utils';
import { CreateSendoutInterviewForm } from './CreateSendoutInterviewForm';

export const CreateSendoutInterviewDrawer = ({ onClose = () => {}, onSaved = () => {} }) => {
  const form = useForm();
  const { clearError, handleSubmit, setError } = form;
  const [uiState, setUIState] = useMountedSafeState({ isLoading: false });

  const handleSave = async formData => {
    const interviewTimeValidationError = getInterviewTimeValidationError(formData);

    if (interviewTimeValidationError) {
      setError(
        interviewTimeValidationError.fieldKey,
        'validate',
        interviewTimeValidationError.message
      );
      return;
    }

    clearError(FORM_FIELDS_MAP.InterviewFromHour.key);
    clearError(FORM_FIELDS_MAP.InterviewToHour.key);

    const payload = buildCreateSendoutInterviewPayload(formData);

    setUIState(prev => ({ ...prev, isLoading: true }));
    try {
      await onSaved({ payload });
    } finally {
      setUIState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.cancel,
        variant: 'outlined',
        onClick: onClose,
        disabled: uiState.isLoading
      },
      GridItemProps: { md: 3 }
    },
    {
      props: {
        text: strings.shared.ui.save,
        variant: 'contained',
        onClick: handleSubmit(handleSave),
        disabled: uiState.isLoading,
        isSaving: uiState.isLoading
      },
      GridItemProps: { md: 3 },
      mode: 'save'
    }
  ];

  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title: strings.sendoutsV2.drawers.createSendoutInterview.title }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <FormContext {...form}>
        <CreateSendoutInterviewForm />
      </FormContext>
    </FPDrawer>
  );
};
